import client from "FrontendJsAssets/common/client";
import { initCopyTexts } from "Functions/copy-text";

initCopyTexts();

$("#new-wishlist-modal").on("show.bs.modal", function () {
    import("./../../components/form/account-wishlist-new").then((module) => {});
});

const wishlistActionsTriggers = document.querySelectorAll(".js-wishlist-trigger-action");

if (wishlistActionsTriggers) {
    wishlistActionsTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            const url = trigger.dataset.url;
            const wishlistId = trigger.dataset.wishlistId || null;

            trigger.classList.add("is-loading");

            if (wishlistId) {
                client
                    .post(url, {
                        customer_wishlist_id: wishlistId,
                    })
                    .then((response) => {})
                    .finally(() => {
                        window.location.reload();
                    });
            } else {
                Eshop.confirm(
                    trigger.dataset.confirmTitle,
                    {
                        denyButtonText: trigger.dataset.denyText,
                        confirmButtonText: trigger.dataset.confirmText,
                    },
                    () => {
                        window.location.href = url;
                    },
                    () => {
                        trigger.classList.remove("is-loading");
                    }
                );
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const wishlistProductSpinners = document.querySelectorAll("r-spinner");

    if (wishlistProductSpinners) {
        const changeQuantity = (event) => {
            const spinner = event.target;
            const productId = spinner.closest("form").querySelector('[name="id"]').value;
            const wishlistId = spinner
                .closest(".c-account-body")
                .querySelector(".js-customer-wishlist").dataset.wishlistId;

            if (spinner.oldValue !== spinner.value) {
                client
                    .post(`/wishlist/update-product/${productId}`, {
                        quantity: spinner.valueOrMin,
                        customer_wishlist_id: wishlistId,
                    })
                    .then((response) => {
                        document.querySelector(".js-wishlist-total").innerHTML = Format.price(
                            response.data.total
                        );
                        document.querySelector(".js-wishlist-subtotal").innerHTML = Format.price(
                            response.data.subtotal
                        );
                    })
                    .finally(() => {
                        // trigger.classList.remove("is-loading");
                        // window.location.reload();
                    });
            }
        };

        wishlistProductSpinners.forEach((rSpinner) => {
            rSpinner.addEventListener("stop", changeQuantity);
            rSpinner.addEventListener("changed", changeQuantity);
        });
    }
});
